import React from "react";
import { Compass, Scale, Footprints } from "lucide-react";
import { CATEGORIES, PILLARS } from "../../mock/mock";

const iconFor = (name) => ({ compass: Compass, scale: Scale, footprints: Footprints }[name] || Compass);

// Positions for floating chips around the big headline (desktop only)
const CHIP_POS = [
  "left-[6%] top-[12%]",
  "left-[2%] top-[52%]",
  "left-[18%] top-[80%]",
  "right-[8%] top-[10%]",
  "right-[3%] top-[46%]",
  "right-[20%] top-[82%]",
];

const DarkChips = () => {
  return (
    <section className="bg-[#41232E] text-[#FFFDF6] pt-24 md:pt-32 pb-16 md:pb-20 relative overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 relative">
        <div className="text-center uppercase tracking-[0.28em] text-[0.72rem] text-[#D8D355] mb-10 om-fade-up">
          Ideas for intentional living
        </div>

        <div className="relative min-h-[280px] md:min-h-[360px] flex items-center justify-center om-fade-up">
          {/* Floating chips (desktop) */}
          <div className="hidden md:block absolute inset-0 pointer-events-none">
            {CATEGORIES.map((c, i) => (
              <span
                key={c}
                className={`absolute ${CHIP_POS[i % CHIP_POS.length]} border border-[#D8D355] text-[#D8D355] rounded-full px-4 py-1.5 text-xs md:text-sm tracking-[0.14em] bg-[#41232E]`}
              >
                + {c}
              </span>
            ))}
          </div>

          <h2 className="font-serif-display text-[3rem] sm:text-[4rem] md:text-[6rem] lg:text-[7rem] leading-[0.95] tracking-[-0.02em] text-center text-[#D8D355]">
            Nothing worth building{" "}
            <em className="italic block md:inline text-[#B995EE]">happens by default.</em>
          </h2>
        </div>

        {/* Chips as inline row on mobile */}
        <div className="md:hidden flex flex-wrap gap-2 justify-center mt-10">
          {CATEGORIES.map((c) => (
            <span
              key={c}
              className="border border-[#D8D355] text-[#D8D355] rounded-full px-3 py-1 text-xs tracking-[0.14em]"
            >
              + {c}
            </span>
          ))}
        </div>

        <p className="mt-16 md:mt-20 text-center max-w-2xl mx-auto text-[#FFFDF6]/80 text-lg leading-relaxed om-fade-up">
          Created by Cynthia D after twenty years observing founders, investors, executives,
          athletes, and other highly accomplished people — The Owner&rsquo;s Mind exists to
          translate what actually works into ideas everyday people can use.
        </p>

        {/* Three feature cards, minimal Kinhive style */}
        <div className="mt-20 md:mt-28 grid md:grid-cols-3 gap-x-12 gap-y-14">
          {PILLARS.map((p, idx) => {
            const Icon = iconFor(p.icon);
            return (
              <div
                key={p.id}
                className="om-fade-up text-center md:text-left"
                style={{ transitionDelay: `${idx * 80}ms` }}
              >
                <div className="flex md:block justify-center mb-6">
                  <Icon size={44} strokeWidth={1.1} className="text-[#D8D355]" />
                </div>
                <h3 className="font-serif-display text-[#FFFDF6] text-xl md:text-2xl mb-3">
                  {p.title}
                </h3>
                <p className="text-[#FFFDF6]/70 leading-relaxed max-w-sm mx-auto md:mx-0">
                  {p.body}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default DarkChips;
